module.exports = __webpack_public_path__ + "c44c2bbfac2d14e59eef37a5099d6e1a.svg";